import { render } from "./Signup.vue?vue&type=template&id=1916305c&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=1916305c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1916305c"]])

export default __exports__